module.exports = __webpack_public_path__ + "assets/dd02fd3272ce9bded0d02517d2bb4047.jpg";